// Ленивая загрузка тяжёлых модулей графиков (ECharts) и карт (MapLibre).

export type ChartModule = typeof import('../charts');

export type MapModule = typeof import('../maps');

export let loadedChartModule: ChartModule | null = null;

export let loadedMapModule: MapModule | null = null;

export let chartModulePromise: Promise<ChartModule> | null = null;

export let mapModulePromise: Promise<MapModule> | null = null;

export async function loadChartModule(): Promise<ChartModule> {
  if (loadedChartModule) return loadedChartModule;
  chartModulePromise ??= import('../charts');
  loadedChartModule = await chartModulePromise;
  return loadedChartModule;
}

export async function loadMapModule(): Promise<MapModule> {
  if (loadedMapModule) return loadedMapModule;
  mapModulePromise ??= import('../maps');
  loadedMapModule = await mapModulePromise;
  return loadedMapModule;
}
